import React from "react";
import Unread from "../../../unread_projects_jobs/Unread";
import { Box, Divider } from "@mui/material";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import HeaderMenuItem from "./HeaderMenuItem";

export default function UserHeader({ unread, onClickLogout, isCompany }) {
  return (
    <>
      {/* 未読プロジェクト・求人（既存） */}
      {!isCompany && (
        <Unread
          projectIndexUrl={unread?.projectIndexUrl}
          jobIndexUrl={unread?.jobIndexUrl}
          unreadProjects={unread?.unreadProjects || []}
          unreadJobs={unread?.unreadJobs || []}
          projectUnreadCount={unread?.projectUnreadCount || 0}
          jobUnreadCount={unread?.jobUnreadCount || 0}
        />
      )}

      {/* ログアウト（PCのみ表示） */}
      <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
        <HeaderMenuItem
          label="ログアウト"
          icon={<LogoutOutlinedIcon />}
          onClick={onClickLogout}
        />
      </Box>
    </>
  );
}
